<template>
  <div class="container mt-5">
    <h2 class="mb-4">Add Item</h2>
    <form @submit.prevent="addItem">
      <div class="row">
        <!-- Display Name -->
        <div class="col-md-6 mb-3">
          <label for="displayName" class="form-label">Display Name</label>
          <input
            type="text"
            class="form-control"
            id="displayName"
            v-model="item.displayName"
            required
          />
        </div>

        <!-- Type -->
        <div class="col-md-6 mb-3">
          <label for="type" class="form-label">Type</label>
          <select class="form-select" id="type" v-model="item.type" required>
            <option value="">Select Type</option>
            <option value="Inventory">Inventory</option>
            <option value="Service">Service</option>
          </select>
        </div>
      </div>

      <div class="mb-3">
        <label for="fileInput" class="form-label">Select Item Image</label>
        <input
          type="file"
          class="form-control"
          id="fileInput"
          @change="onFileChange"
        />
      </div>

      <!-- Submit Button and Spinner -->
      <button type="submit" class="btn btn-primary" :disabled="loading">
        <span
          v-if="loading"
          class="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        Save Item
      </button>
      <button
        type="button"
        class="btn btn-secondary ms-2"
        @click="$router.back()"
      >
        Cancel
      </button>
    </form>

    <!-- Result Message Placeholder -->
    <div v-if="message" class="mt-4">
      <div
        :class="{
          'alert alert-success': isSuccess,
          'alert alert-danger': !isSuccess,
        }"
      >
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { getOauthToken } from "@/helper/utils1"; // Use `@` for the src directory
import { clearLocalStorageItem } from "@/localCache";
import { BC_API_BASE_URL } from "@/apiConfig";
import { logout } from "@/helper/utils1"; // Use `@` for the src directory


export default {
  data() {
    return {
      item: {},
      message: null,
      isSuccess: false,
      loading: false, // Tracks the loading state
      itemImageFile: null, // Store the selected image file
    };
  },
  methods: {
    // Store the selected file when it changes
    onFileChange(event) {
      this.itemImageFile = event.target.files[0];
    },

    async addItem() {
      if (!this.itemImageFile) {
        this.message = "Please select item image!";
        return;
      }

      this.loading = true; // Start loading
      this.message = ""; // Clear any previous message
      // Process to save item details
      try {
        const itemsUrl = BC_API_BASE_URL + `/items`;
        let response = await axios.post(
          itemsUrl,
          this.item, // This sends the item JSON object in the request body
          {
            headers: {
              Authorization: `Bearer ` + getOauthToken(),
              "Content-Type": "application/json", // Set content type to JSON
            },
          }
        );

        let item = response.data;
        console.log(item);
        // Perform the PATCH request
        response = await axios.patch(
          BC_API_BASE_URL + `/items(${item.id})/picture/pictureContent`,
          this.itemImageFile,
          {
            headers: {
              Authorization: `Bearer ` + getOauthToken(),
              "Content-Type": "application/octet-stream", // Specify binary content
              "If-Match": "*", // Additional header for conditional update
            },
          }
        );
        this.message = "Item added successfully!";
        this.isSuccess = true;
        console.log(response);
        clearLocalStorageItem(itemsUrl); // flush the cache so that the customer list will fetched fresh

      } catch (error) {
        console.log(error);
        this.message = "Failed to add item: " + error.message;
        this.isSuccess = false;
        if (error.status == 401) {
          logout(this.$router);
        }
      } finally {
        this.loading = false; // Stop loading after response
      }
    },
  },
};
</script>
